package com.neurobs.ccabserver.translationadmin.components.testupload.components

import com.neurobs.ccabserver.translationadmin.states.TestUploadStateGenerator
import com.neurobs.react.semanticui.{UiButtonFactory, UiInputFactory}
import org.scalajs.dom
import org.scalajs.dom.ProgressEvent
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.{React, ReactElement}

@react
object FileUploadInput {

  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val testUploadState = TestUploadStateGenerator.accessState

    val fileInputRef = React.createRef[dom.html.Input]

    def uploadedFile = {
      if (fileInputRef.current == null || fileInputRef.current.files.length == 0) None
      else Some(fileInputRef.current.files.item(0))
    }

    def readUploadedFile: () => Unit = () => {
      uploadedFile.map(file => {
        val fileReader = new dom.FileReader()
        fileReader.readAsText(file)
        fileReader.onload = (e: ProgressEvent) => {
          val fileString = fileReader.result.asInstanceOf[String]
          testUploadState.uploadedFileState.setValue(Some(fileString))
        }
      })
    }

    props.enclosingElement(
      Seq[ReactElement](
        UiInputFactory.FileInput("Select ccab test file", fileInputRef, ".json"),
        UiButtonFactory.Button("Upload file", handleClick = readUploadedFile)
      )
    )
  }

}
